import { HttpBackend, HttpClient } from '@angular/common/http';
import {CommonModule,HashLocationStrategy, LOCATION_INITIALIZED, LocationStrategy} from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {APP_INITIALIZER, ErrorHandler, Injector, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { ApmErrorHandler, ApmModule } from "@elastic/apm-rum-angular";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainHomeComponent } from './components/main-home/main-home.component';
import { HttpRequestInterceptor } from './helpers/interceptors/auth-interceptor';
import { RefreshInterceptor } from './helpers/interceptors/refresh-interceptor';
import { AppLayoutModule } from './layout/app.layout.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AuthConstants } from './constants/auth/auth-constants';
import { EditorModule } from "primeng/editor";
import { TextEditorComponent } from './components/tools/text-editor/text-editor.component';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SignedInGuard } from './helpers/guards/signed-in.guard';
import { AffichageCguModule } from "./components/affichage-cgu/affichage-cgu.module";
import { DemandeResiliationComponent } from './components/demande-resiliation/demande-resiliation.component';

import { NousContacterComponent } from './components/nous-contacter/nous-contacter.component';
import { MesCourriersComponent } from './components/mes-courriers/mes-courriers.component';
import { SuiviDemandesComponent } from './components/suivi-demandes/suivi-demandes.component';
import { GestionSalariesComponent } from "./components/gestion-salaries/gestion-salaries.component";

import { FaqComponent } from './components/faq/faq.component';
import { ToastModule } from 'primeng/toast';
import { TranslationUtil } from "./utils/translation-util";
import {TableUtils} from "./utils/table-utils";
import { MesContratsComponent } from './components/mes-contrats/mes-contrats.component';
import { CotisationsComponent } from './components/cotisations/cotisations.component';
import { SubscriptionModule } from 'lib-subscription';
import { GestionDesSalariesModule } from 'gestion-salaries';
import { AccueilEntrepriseModule } from 'accueil-entreprise';
import { CoordonneesBancairesModule } from 'coordonnees-bancaires';
import { LibDocumentsModule } from 'lib-documents';
import { LibAlertsDsnModule } from 'lib-alerts-dsn';
import { DocumentsDsnModule } from 'lib-documents-dsn';

import { LibMonProfilModule } from 'lib-mon-profil';
import { LibGestionFilialeModule } from 'lib-gestion-filiale-entreprise';
import { DemandeResiliationModule } from 'demande-resiliation';
import { NousContacterModule } from 'nous-contacter';
import { MesCourriersModule } from 'mes-courriers';
import { SuiviDemandesModule } from 'suivi-demandes';
import { LibFaqModule } from 'lib-faq';
import { MonAdhesionModule } from 'mon-adhesion';
import { LibListeCotisationModule } from 'lib-liste-cotisation';
import { SuiviDemandesAdhesionModule } from 'suivi-demandes-adhesion';
import { MesServicesComponent } from './components/mes-services/mes-services.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SubscriptionComponent } from './components/subscription/subscription.component';



import { CoordonneesBancairesComponent } from './components/coordonnees-bancaires/coordonnees-bancaires.component';

import { DocumentsContractuelsComponent } from './components/documents-contractuels/documents-contractuels.component';
import { MonProfilComponent } from './components/mon-profil/mon-profil.component';

import { Router, RouterModule } from "@angular/router";
import { SuiviDemandeAdhesionComponent } from './components/suivi-demande-adhesion/suivi-demande-adhesion.component';

import { AlertsDsnComponent } from './components/alerts-dsn/alerts-dsn.component';

import { MereFilialeComponent } from './components/mere-filiale/mere-filiale.component';

import { TimeoutComponent } from './helpers/timeout/timeout.component';
import { AuthSharedModule } from './shared/auth-shared.module';
import { DocumentsDsnComponent } from './components/documents-dsn/documents-dsn.component';
import {commentpipe} from "./components/mes-services/commentpipe ";
import { GestionCabinetsComptablesComponent } from './components/gestion-cabinets-comptables/gestion-cabinets-comptables.component';
import {LibGestionCabinetsComptablesModule} from "gestion-cabinet-comptable";
import {PageServiceService} from "./components/mes-services/page-service.service";
import {MenuUtil} from "./utils/menu-utils";
import { LoginModule } from "./components/auth/login/login.module";
import { EnvironmentProvider } from './providers/environment.provider';
import { ForbiddenInterceptor } from './helpers/interceptors/forbidden-interceptor';
import {DecimalFormatterDirective} from "./directives/decimal-formatter-directive";
import { firstValueFrom } from 'rxjs';
import { CookieErrorComponent } from './components/cookie-consent-error-page/cookie-error.component';
import { DialogModule } from 'primeng/dialog';
import {GlobalUtils} from "./utils/global-utils";
import { EnvironmentService } from './services/environment.service';
import { CustomTranslateLoader } from './services/language/custom-translate-loader';
import { ConfigurationProvider } from './providers/configuration.provider';


export function getServerUrl(environmentService: EnvironmentService): string {
  return environmentService.get('serverUrl') as string;
}

@NgModule({
  declarations: [
    commentpipe,
    AppComponent,
    MainHomeComponent,
    TextEditorComponent,
    DemandeResiliationComponent,
    NousContacterComponent,
    MesCourriersComponent,
    SuiviDemandesComponent,
    FaqComponent,
    GestionSalariesComponent,
    MesServicesComponent,
    MonProfilComponent,
    MesContratsComponent,
    CotisationsComponent,
    CoordonneesBancairesComponent,
    DocumentsContractuelsComponent,
    SuiviDemandeAdhesionComponent,
    AlertsDsnComponent,
    MereFilialeComponent,
    SubscriptionComponent,
    TimeoutComponent,
    DecimalFormatterDirective,
    CookieErrorComponent,
    DocumentsDsnComponent,
    GestionCabinetsComptablesComponent,
    DecimalFormatterDirective

  ],
  imports: [
    ApmModule,
    ProgressSpinnerModule,
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    CommonModule,
    RippleModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    TooltipModule,
    EditorModule,
    ToastModule,
    SubscriptionModule,
    GestionDesSalariesModule,
    AccueilEntrepriseModule,
    CoordonneesBancairesModule,
    LibDocumentsModule,
    LibAlertsDsnModule,
    DocumentsDsnModule,
    RouterModule,
    LibMonProfilModule,
    LibGestionFilialeModule,
    LibGestionCabinetsComptablesModule,

    TranslateModule.forRoot({
      defaultLanguage: 'fr',
        extend: true,
        loader: {
          provide: TranslateLoader,
          useClass: CustomTranslateLoader,
          deps: [HttpBackend]
    }
    }),
    AffichageCguModule,
    AuthSharedModule,
    DemandeResiliationModule ,
    NousContacterModule,
    MesCourriersModule,
    SuiviDemandesModule,
    LibFaqModule,
    MonAdhesionModule,
    LibListeCotisationModule,
    SuiviDemandesAdhesionModule,
    LoginModule
  ],
  providers: [
    EnvironmentProvider,
    ConfigurationProvider,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: AuthConstants.SERVER_URL,
      useFactory: getServerUrl,
      deps: [EnvironmentService]
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true
    },
    SignedInGuard,
    {
      provide: 'TableUtils',
      useValue: TableUtils
    },
    {
      provide: 'TranslationUtil',
      useValue: TranslationUtil
    },
    {
      provide: 'GlobalUtils',
      useValue: GlobalUtils
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ForbiddenInterceptor,
      multi: true
    },
    SignedInGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translateService: TranslateService, service: PageServiceService, routerService: Router,cookieService: CookieService) {
    TranslationUtil.setTranslateService(translateService);
    MenuUtil.setService(service);
    MenuUtil.setCookieService(cookieService);
    MenuUtil.setRouter(routerService);
  }
}
